import { Icon } from "@iconify/react";
import React from "react";
import { buildAppLink } from "../../utils/landingRedirect";

type ToolsLandingNavLink = {
  label: string;
  href: string;
};

interface ToolsLandingNavProps {
  links?: ToolsLandingNavLink[];
  ctaLabel?: string;
}

const logoMaskStyle: React.CSSProperties = {
  WebkitMask: 'url("/logo/logo.png") center / contain no-repeat',
  mask: 'url("/logo/logo.png") center / contain no-repeat',
};

const defaultLinks: ToolsLandingNavLink[] = [
  { label: "Tools", href: "/tools" },
  { label: "How it works", href: "#how-it-works" },
  { label: "FAQ", href: "#faq" },
];

const ToolsLandingNav: React.FC<ToolsLandingNavProps> = ({
  links = defaultLinks,
  ctaLabel = "Open YouWo",
}) => (
  <nav className="yw-consumer-nav yw-tools-nav" aria-label="YouWo tools navigation">
    <a className="yw-consumer-brand" href="/">
      <span aria-hidden="true" className="yw-consumer-logo-mark" style={logoMaskStyle} />
      <strong>YouWo</strong>
    </a>

    <div className="yw-consumer-nav-links">
      {links.map((link) => (
        <a href={link.href} key={`${link.label}-${link.href}`}>
          {link.label}
        </a>
      ))}
    </div>

    <div className="yw-consumer-nav-actions">
      <a className="yw-consumer-language-trigger yw-tools-nav-secondary" href="/tools">
        <Icon icon="lucide:grid-2x2" />
        All tools
      </a>
      <a className="yw-consumer-start" href={buildAppLink()} target="_blank" rel="noopener noreferrer">
        {ctaLabel}
      </a>
    </div>
  </nav>
);

export default ToolsLandingNav;
